import { shortDate } from "@/lib/format";

// Builds the live forecast view model from real API data only (no invented uncertainty bands).
export const buildLiveForecast = ({ summary, rows, seasons, metric }) => {
  const stdKey = `${metric}Std`;
  let days;
  let current;
  if (rows) {
    days = rows.map((r) => ({ date: r.targetDate, label: shortDate(r.targetDate), horizon: r.horizon, value: r[metric], std: r[stdKey] }));
    current = rows[0][stdKey] - rows[0][metric];
  } else {
    const s = summary.metrics[metric];
    current = s.seasonToDate;
    let acc = current;
    days = summary.daily[metric].map((d, i) => {
      acc += d.value;
      return { date: d.date, label: shortDate(d.date), horizon: i + 1, value: d.value, std: acc };
    });
  }
  const issueDate = summary.metrics[metric].issueDate;
  const observed = seasons
    ? seasons.points.filter((p) => p.currentObserved != null).slice(-14).map((p) => ({ label: p.label, observed: p.currentObserved }))
    : [{ label: shortDate(issueDate), observed: null }];
  if (observed.length) {
    observed[observed.length - 1].forecast = current;
    observed[observed.length - 1].anchor = true;
  }
  const s = summary.metrics[metric];
  return {
    current,
    projected: days[days.length - 1].std,
    added: days.reduce((a, d) => a + d.value, 0),
    normalNext7: s.normalNext7,
    days,
    issueLabel: shortDate(issueDate),
    points: [...observed, ...days.map((d) => ({ label: d.label, forecast: d.std, daily: d.value, lead: d.horizon }))],
  };
};
